export default {
    "name": "InterchangeRecords",
    "kind": "HoudiniQuery",
    "hash": "65f368ec5963b17e60495c8261cf1cb3fa82c020023045d98c9f27218e636b0b",

    "raw": `query InterchangeRecords($filter: InterchangeRecordFilter) {
  interchangeRecords(filter: $filter) {
    items {
      id
      interchangeNumber
      subInterchangeNumber
      inventoryType {
        id
      }
      make
      model
      firstYear
      lastYear
      option
      side
      listPrice
      exactApplicationNotes
      inexactApplicationNotes
      attachments {
        rank
        public
        file {
          mimetype
          name
          size
          id
          path
        }
        id
      }
    }
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "interchangeRecords": {
                "type": "InterchangeRecordList",
                "keyRaw": "interchangeRecords(filter: $filter)",

                "selection": {
                    "fields": {
                        "items": {
                            "type": "InterchangeRecord",
                            "keyRaw": "items",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "interchangeNumber": {
                                        "type": "String",
                                        "keyRaw": "interchangeNumber",
                                        "visible": true
                                    },

                                    "subInterchangeNumber": {
                                        "type": "String",
                                        "keyRaw": "subInterchangeNumber",
                                        "visible": true
                                    },

                                    "inventoryType": {
                                        "type": "InventoryType",
                                        "keyRaw": "inventoryType",
                                        "nullable": true,

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "make": {
                                        "type": "String",
                                        "keyRaw": "make",
                                        "visible": true
                                    },

                                    "model": {
                                        "type": "String",
                                        "keyRaw": "model",
                                        "visible": true
                                    },

                                    "firstYear": {
                                        "type": "UInt",
                                        "keyRaw": "firstYear",
                                        "visible": true
                                    },

                                    "lastYear": {
                                        "type": "UInt",
                                        "keyRaw": "lastYear",
                                        "visible": true
                                    },

                                    "option": {
                                        "type": "String",
                                        "keyRaw": "option",
                                        "visible": true
                                    },

                                    "side": {
                                        "type": "SideEnum",
                                        "keyRaw": "side",
                                        "visible": true
                                    },

                                    "listPrice": {
                                        "type": "Decimal2",
                                        "keyRaw": "listPrice",
                                        "visible": true
                                    },

                                    "exactApplicationNotes": {
                                        "type": "String",
                                        "keyRaw": "exactApplicationNotes",
                                        "visible": true
                                    },

                                    "inexactApplicationNotes": {
                                        "type": "String",
                                        "keyRaw": "inexactApplicationNotes",
                                        "visible": true
                                    },

                                    "attachments": {
                                        "type": "InterchangeRecordAttachment",
                                        "keyRaw": "attachments",

                                        "selection": {
                                            "fields": {
                                                "rank": {
                                                    "type": "Int",
                                                    "keyRaw": "rank",
                                                    "visible": true
                                                },

                                                "public": {
                                                    "type": "Boolean",
                                                    "keyRaw": "public",
                                                    "visible": true
                                                },

                                                "file": {
                                                    "type": "File",
                                                    "keyRaw": "file",

                                                    "selection": {
                                                        "fields": {
                                                            "mimetype": {
                                                                "type": "String",
                                                                "keyRaw": "mimetype",
                                                                "visible": true
                                                            },

                                                            "name": {
                                                                "type": "String",
                                                                "keyRaw": "name",
                                                                "visible": true
                                                            },

                                                            "size": {
                                                                "type": "Int",
                                                                "keyRaw": "size",
                                                                "visible": true
                                                            },

                                                            "id": {
                                                                "type": "Int",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            },

                                                            "path": {
                                                                "type": "String",
                                                                "keyRaw": "path",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "filter": "InterchangeRecordFilter"
        },

        "types": {
            "InterchangeRecordFilter": {
                "id": "UInt",
                "interchangeNumber": "String",
                "inventoryTypeId": "UInt",
                "make": "String",
                "model": "String",
                "subInterchangeNumber": "String",
                "vehicleYear": "UInt"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=83b123246c2042e9ab4d6a93bcde4df6c2d84fd6def810100bb6af9f39c9d7cb";